// extracted by mini-css-extract-plugin
export default {"Title":"AddCompany_Title__944Uc","FormGrid":"AddCompany_FormGrid__r7b7A","Actions":"AddCompany_Actions__VDpWH"};